/**
 * API exports
 *
 * Re-exports typed endpoints directly from @investhinks/api-client.
 * This provides full TypeScript support and eliminates wrapper overhead.
 */
import { authEndpoints, createRestApiAdapter, type RegisterInput, usersEndpoints } from "@investhinks/api-client";

import configuration from "../config/configuration";

// Re-export all endpoints and types from api-client
export * from "@investhinks/api-client";

const { apiUrl } = configuration;

// Initialize the API client
const Api = createRestApiAdapter({ path: apiUrl });
export default Api;

// Auth-related helper functions with simplified signatures
export const login = (identifier: string, password: string) => authEndpoints.login({ identifier, password });

export const signUp = (body: RegisterInput) => authEndpoints.register(body);

export const uploadFile = (file: File) => authEndpoints.uploadFile(file);

export const getLocales = () => authEndpoints.getLocales();

export const forgotPassword = (email: string) => authEndpoints.forgotPassword({ email });

export const resetPassword = (code: string, password: string, passwordConfirmation: string) =>
  authEndpoints.resetPassword({ code, password, passwordConfirmation });

export const confirmRemoval = (token: string) => usersEndpoints.confirmRemoval(token);
